<template>
  <div class="user__site__rating">
    <v-row>
      <v-col>
        <UserSetRating :rate="CalculateAvaregeRate(calculateBankRate())" :userInfo='userInfo' :HaveChanges='HaveChanges'
          :count="siteInfo.length" @cancelChanges="cancelChanges" @init="init" @setCheckBox="setCheckBox($event)"
          @clearRate='clearRate' @clearGood="clearGood" @clearBad="clearBad" @clearComment="clearComment"
          @saveRating='saveSiteRating'>
          <template v-slot:title>
            <a :href="`https://${site_name}`" target="_blank">{{
              site_name
            }}</a>
          </template>
        </UserSetRating>
      </v-col>
    </v-row>
    <v-row><v-col>
        <RatingBySite :siteInfo="siteInfo" @init="init" />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import moment from "moment";
import RatingBySite from "@/components/Raiting/RatingBySite.vue";
import UserSetRating from "@/components/Raiting/UserSetRating.vue";
import UserDefaultObject from '@/service/UserDefaultObject.js'
import { DeepCopy } from "@/service/DeepCopy";

const dubleUI = DeepCopy(UserDefaultObject)
const UI = DeepCopy(UserDefaultObject)

export default {
  name: "user__site__rating",
  components: {
    RatingBySite,
    UserSetRating,
  },
  data: () => ({
    moment,
    comment: "",
    rate: null,
    site_name: null,
    siteInfo: [],
    dubleUserInfo: dubleUI,
    userInfo: UI,
  }),
  computed: {
    site_id() {
      return this.$store.getters.get_site_id;
    },
    HaveChanges() {
      if (
        JSON.stringify(this.dubleUserInfo) !== JSON.stringify(this.userInfo)
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    calculateBankRate() {
      const result = [];
      const Rate = [];
      if (this.siteInfo.length > 0) {
        Array.from(this.siteInfo).map((row) => {
          for (const [key, value] of Object.entries(row.rate)) {
            Rate[value.name] = new Array();
          }
        });
        Array.from(this.siteInfo).map((row) => {
          for (const [key, value] of Object.entries(row.rate)) {
            Rate[value.name].push(value.rate);
          }
        });
        for (const [key, value] of Object.entries(Rate)) {
          result.push({ name: key, rate: this.getAvarege(value) });
        }
      }

      return result;
    },
    async saveSiteRating() {
      if (this.userInfo.comment !== "") {
        const saveObj = {
          site_id: this.site_id ? this.site_id : this.$route.query.site_id,
          rate: [{ name: '', description: '', rate: this.userInfo.rate }],
          comment: this.userInfo.comment,
          good: this.userInfo.good,
          bad: this.userInfo.bad,
          recommend: this.userInfo.recommend,
          goodOrBad: this.userInfo.goodOrBad,
        };
        await this.$store.dispatch("SET_RATE_AND_COMMENT_FOR_SITE", saveObj);
        this.init();
      }
    },
    clearRate() {
      this.userInfo.rate = 0
    },

    setCheckBox(allProduct) {
      this.userInfo.allProduct = Object.assign([], allProduct);
    },
    cancelChanges() {
      this.userInfo = this.DeepCopy(this.dubleUserInfo);
    },
    clearComment() {
      this.userInfo.comment = "";
    },
    clearGood() {
      this.userInfo.good = "";
    },
    clearBad() {
      this.userInfo.bad = "";
    },
    // removeComment() {
    //   const obj = {
    //     site_id: this.site_id,
    //     user_id: this.$store.getters.user_id,
    //   };
    //   this.$store.dispatch("REMOVE_USER_RATE_FROM_SITE", obj);
    //   this.init();
    // },

    async init() {
      const getData = async (getObj) => {
        this.rate = Array.from(this.$store.getters.ratingConfig);
        const data = await this.$store.dispatch("GET_USER_SITE_INFO", getObj);

        const { userInfo, dubleUserInfo } = this.initUserObjectRating(
          this.rate,
          data.userInfo,
          data.allProduct
        );
        this.userInfo = userInfo;
        this.dubleUserInfo = dubleUserInfo;
        this.site_name = data.site_name.name;
        this.siteInfo = await this.$store.dispatch("GET_SITE_COMMENT", getObj);
      }
      if (!this.site_id) {
        if (this.$route.query.site_id) {
          const getObj = {
            site_id: this.$route.query.site_id,
          };
          await getData(getObj)
          return
        }
      }
      if (this.site_id) {
        if (this.$store.getters.ratingConfig.length == 0) {
          await this.$store.dispatch("GET_RATING_CONFIG");
        }
        const getObj = {
          site_id: this.site_id,
        };
        await getData(getObj)
        return
      }

      this.$router.push("/rating");
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style lang="sass" scoped>
</style>
